import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=37c36aee&scoped=true"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"
import style0 from "./Scanner.vue?vue&type=style&index=0&id=37c36aee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c36aee",
  null
  
)

export default component.exports